import React from "react";
import { AvForm } from "availity-reactstrap-validation";
import { CardBody, Card } from "reactstrap";

import { PrinterRowData, PrinterAppId } from "../../../types";
import { SalesModeApiItem } from "../../../hooks/salesModesHelper";

import PrintNote from "../PrintNote";
import PrintKitchenTicket from "../PrintKitchenTicket";
// import PrintCustomerAddress from "../PrintCustomerAddress";
import PrintCustomerInformation from "../PrintCustomerInformation";

type UserCardType = {
    rowData: PrinterRowData;
    salesModesData: SalesModeApiItem[];
    appId: PrinterAppId;
};

function UserCard({ rowData, salesModesData, appId }: UserCardType) {
    return (
        <Card
            style={{
                fontSize: "17px",
            }}
        >
            <AvForm>
                <CardBody>
                    <PrintNote />
                    <div className="border-footer__clz p-1" />
                    <PrintKitchenTicket
                        rowData={rowData}
                        salesModesData={salesModesData}
                        appId={appId}
                    />
                    {/* <div className="border-footer__clz p-1" />
                    <PrintCustomerAddress
                        rowData={rowData}
                        salesModesData={salesModesData}
                        appId={appId}
                    /> */}
                    <div className="border-footer__clz p-1" />
                    <PrintCustomerInformation
                        rowData={rowData}
                        salesModesData={salesModesData}
                        appId={appId}
                    />
                </CardBody>
            </AvForm>
        </Card>
    );
}

export default UserCard;
